import styled, { css } from 'styled-components'

export const Wrapper = styled.label<{ $centered?: boolean }>(
  ({ theme, $centered }) => css`
    display: flex;
    ${$centered && 'justify-content: center;'};
    align-items: flex-start;
    gap: 0.5rem;
    cursor: pointer;
    font-size: 0.9375rem;
    color: #374151;

    .checkbox-trigger {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;

      &:checked {
        & ~ .styled-checkbox {
          &::after {
            opacity: 1;
            scale: 1;
          }
        }
      }
    }

    .styled-checkbox {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      border: 2px solid ${theme.colors.text};
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      &::after {
        content: '✓';
        color: #181d27;
        font-weight: bold;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        opacity: 0;
        scale: 0.5;
        transition:
          opacity 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28),
          scale 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
      }
    }
  `,
)
